import { useEffect, useRef, useState } from "react";
import { Stepper } from "@JohnLewisPartnership/jl-design-system/dist/components/stepper";
import styles from "./QuantitySelector.module.scss";
import { ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED } from "../../constants/constants";

const inputId = "quantity";

type Props = {
  /**
   * A boolean indicating whether the quantity selector is disabled.
   */
  disabled?: boolean;
};

/**
 * Displays a quantity selector for the product.
 */
export const QuantitySelectorUI = ({ disabled = false }: Props) => {
  const [quantity, setQuantity] = useState<number>(1);
  const hasMountedRef = useRef<boolean>(false);

  useEffect(() => {
    const handleResetQuantitySelectorState = () => {
      setQuantity(1);
    };

    window.addEventListener(
      ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED,
      handleResetQuantitySelectorState,
    );

    return () => {
      window.removeEventListener(
        ADD_TO_BASKET_ESI_SUCCESSFULLY_ADDED,
        handleResetQuantitySelectorState,
      );
    };
  }, []);

  useEffect(() => {
    if (hasMountedRef.current) {
      const e = new CustomEvent("ADD_TO_BASKET_ESI:QUANTITY_UPDATED", {
        detail: {
          quantity,
        },
      });
      window.dispatchEvent(e);
    } else {
      hasMountedRef.current = true;
    }
  }, [quantity]);

  return (
    <div
      data-testid="product:quantity-selector"
      className={styles.quantitySelector}
    >
      <label htmlFor={inputId}>Quantity</label>
      <Stepper
        data-testid="stepper"
        value={quantity}
        disabled={disabled}
        inputId={inputId}
        handleChange={(value) => setQuantity(value)}
        inputName={"quantity-selector"}
        min={1}
        max={99}
      />
    </div>
  );
};
